import { z } from 'zod/v4';

/**
 * The following characters count as special characters:
 * ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \ , > < ' : ; | _ ~ ` + =
 * The non-leading, non-trailing space character is also treated as a special character.
 */
const SPECIAL_CHARS = `^$*.[]{}()?-"!@#%&/\\,><':;|_~\`+= `.split('');

export const passwordSchema = z
  .string()
  .min(8, 'Password must be at least 8 characters')
  .max(256, 'Password must be at most 256 characters')
  .regex(/\d/, 'Use a number')
  .regex(/[a-z]/, 'Use an lowercase letter')
  .regex(/[A-Z]/, 'Use an uppercase letter')
  .refine((password) => SPECIAL_CHARS.some((ch) => password.includes(ch)), {
    error: 'Use a special character',
  })
  .refine((password) => password.trim() === password, {
    error: 'Cannot start or end with a space',
  });

export const confirmPasswordRefine = (data: {
  newPassword: string;
  confirmPassword: string;
}) => data.newPassword === data.confirmPassword;

export const confirmPasswordRefineOptions = {
  error: 'Passwords do not match',
  path: ['confirmPassword'],
};
